import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NicaMaster } from '../../../components/nica-master-component/nica-master.component';
import { NicaDataGridComponent } from '../../../components/nica-data-grid/nica-data-grid.component';
import { AnaColumn, FormsTemplateService } from '../../../services/forms-template.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Apiservice } from '../../../services/api.service';
import { ComponentService } from '../../../services/component.service';
import { OverlaySideFormService } from '../../../components/shared/overlay-side-form/overlay-side-form.service';
import { NicaMenuService } from '../../../services/nica-menu.service';
import { AnagraficaService } from '../../../services/anagrafica.service';
import { HttpClient } from '@angular/common/http';
import { alert, confirm } from 'devextreme/ui/dialog';
import { formatNumber } from '@angular/common';

@Component({
  selector: 'app-gestione-miscelazioni-rifiuti',
  templateUrl: './gestione-miscelazioni-rifiuti.component.html',
  styleUrls: ['./gestione-miscelazioni-rifiuti.component.css']
})


export class GestioneMiscelazioniRifiutiComponent extends NicaMaster implements OnInit, AfterViewInit {



  @ViewChild('dataGrid', { static: false }) nicaDataGrid: NicaDataGridComponent


  @Input() itemData: any;


  @Input() formData;

  @Output() outputEmit: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendSelectionRow: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  showGrid: boolean = false;
  dataSourceMiscelazione: any = [];
  colonneGrigliaMiscelazione: AnaColumn[] = []
  toolbarButtonsTop: any = []
  constructor(


    public apiservice: Apiservice,


    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,

    public anagraficaService: AnagraficaService,
    public http: HttpClient,


  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,


    );

  }

  ngAfterViewInit(): void {
    // this.nicaDataGrid.startAllEditor();
  }

  ngOnInit() {
    //let colonneGrigliaMiscelazione = JSON.parse(JSON.stringify(this.formTemplateService.getService('RintraccMiscelazione')))

    //this.colonneGrigliaMiscelazione = colonneGrigliaMiscelazione
    this.showToolBar = false;

    if (this.itemData) {

      //let formData = this.itemData[0].data;

      this.rowData['idSede'] = this.formData.idLotto_Sede;
      this.rowData['idPosizioneRifiuto'] = this.formData.idPosizioneRifiuto;

      //console.log('itemData-->', this.rowData)

    } else {

      this.activatedroute.queryParams
        .subscribe(params => {

          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName

          this.setGlobalVariableFromParams(params);
          this.titleDynamic = this.itemData[0].title;
          let formData = this.itemData[0].data
          this.rowData['idSede'] = formData.idLotto_Sede;
          this.rowData['idPosizioneRifiuto'] = formData.idPosizioneRifiuto;
        });
    }

    this.setViewMiscelazione()

  }

  async setViewMiscelazione() {

    this.filterID = this.itemData


    this.titleDynamic = this.titleDynamic;

    this.rowData['idSede'] = this.formData.idLotto_Sede;
    this.rowData['idPosizioneRifiuto'] = this.formData.idPosizioneRifiuto;


    /* this.colonneGrigliaMiscelazione.forEach(res=>{

      res.data.forEach(rrr=>{
        if(rrr.dataField == 'percentuale'){
          //rrr.colVisible = true;
        }
      })
    }) */


    await this.getDataSource();

    
  }

  getDataSource() {
    let inData = this.filterID
    const IdMovimento = inData['idMovimento'];
    const DataRegistrazione = inData['dataRegistrazione'];
    const eer = inData['eer'];
    const idStatoFisico = inData['idStatoFisico'];
    const RiferimentoEER = inData['riferimentoEER'];
    const quantita = inData['quantita'];

    const APISET = 'MovimentoRifiuti/GetListaSchedeMiscelazione';
    //const APISET = 'SchedaRifiutoMiscelazione/8';

    let queryParams = `?IdMovimento=${IdMovimento}&DataRegistrazione=${DataRegistrazione}&EER=${eer}&IdStatoFisico=${idStatoFisico}&RiferimentoEER=${RiferimentoEER}&QtaScaricata=${quantita}`;
    
    const peso = formatNumber(Number(quantita), 'it-IT', '1.0-3');
    let pesoMovimento = 'Totale Peso scaricato(Kg): ' + peso
    this.toolbarButtonsTop=[
      {
        id: 'textPeso',
        text: pesoMovimento,
        icon: null,
        disabled: false,
        image:null ,
        separator: null,
        visible: true,
        hint: '',
        name: 'peso',
        position:'left',
        widget: 'textDesc'
      }
    ]

    return this.anagraficaService.getElenco(APISET, '', queryParams).then(ress => {

      if (ress['items']) {
        ress = ress['items']

      }

      this.dataSourceMiscelazione = ress

      if(this.dataSourceMiscelazione.length == 0){
        //this.userComponentService.destroyCurrentOpenPopUp('GestioneMiscelazioniRifiutiComponent');
        this.showGrid = false;

        let datatoSendOutput = {
          name: 'return',
          listaMiscelazione: null
        }
        this.outputEmit.emit(datatoSendOutput);
        return 
      }

      this.showGrid = true;
    })

    
  }

  gridEventMiscelazione() {

  }

  gridEventCellValue(event) {

    if (event.name == 'cellValueChange') {
      let dataCellEdit = this.nicaDataGrid.editorCellByRow;

      let colsHeader = this.nicaDataGrid.colsHeader;
      let rowIndex = event.rowIndex;
      let rowData = event.rowData;
      let value = event.value;
      if (event.cellName == "lega") {
        if (value) {
          if (rowData.legaChiudi) {
            rowData.legaChiudi = false
            this.dataSourceMiscelazione[rowIndex].legaChiudi = false
            this.nicaDataGrid.editorData[rowIndex]['data'].legaChiudi = false
          }

        }
      }

      if (event.cellName == "legaChiudi") {
        if (value) {
          if (rowData.lega) {
            this.dataSourceMiscelazione[rowIndex].lega = false
            this.nicaDataGrid.editorData[rowIndex]['data'].lega = false
          }

        }
      }

      if (event.cellName == "quantita") {

       /*  let value = event.value;
        if (value) {
          let quantitaTrattata = rowData.quantitaTrattata;

          let calcPerc = Math.floor((value / quantitaTrattata) * 100).toFixed(2)
          this.dataSourceMiscelazione[rowIndex].percentuale = calcPerc;
          this.nicaDataGrid.editorData[rowIndex]['data'].percentuale = calcPerc
          //alert(calcPerc.toString(),'dddd')
        }
 */

        let col = this.nicaDataGrid.editorData[rowIndex]['colProp']['quantita']
        this.nicaDataGrid.calcolaSomma(col)
      }
      console.log('gridEventCellValue...', event);
      console.log('dataCellEdit...', dataCellEdit[rowIndex]);
    }
  }

  rispostaBottoni(ev) {

    switch (ev) {


      case 16:


        let datatoSendOutput = {
          name: 'returnMov',
          listaTracciabilita: null
        }
        this.outputEmit.emit(datatoSendOutput);




        break;
      case 0:

        confirm("Abbandonando, eventuali modifiche non verranno salvate, confermi l'abbandono ed il salvataggio del movimento di carico?", 'Attenzione!').then(confirmRes => {

          if (confirmRes) {

            let datatoSendOutput = {
              name: 'return',
              listaMiscelazione: null
            }
            this.outputEmit.emit(datatoSendOutput);
          }
        })



        break;
      case 15:

        this.convalidDataGrid()


        break;

    }
  }
  convalidDataGrid() {

    //let checkValidation = true

    const dataB = this.nicaDataGrid.saveEditorDataInbatch();

    let lista = []

    dataB.map(res => {

      if (res.quantita) {
        lista.push(res)
      }

    })

    if (dataB.length > 0) {
      let quantitaKgMovimento = this.filterID['quantita'];

      let rows = this.nicaDataGrid.righe.map(row => {
        let ro = row.nativeElement

        if (ro.classList.contains('error-row')) {
          ro.classList.remove('error-row')
        }

        return ro;
      })

      const APISETC = 'MovimentoRifiuti/ConvalidaListaMiscelazione?QuantitaKg=' + quantitaKgMovimento;

      this.nicaDataGrid.rowSelected = [false];
      this.anagraficaService.actionPut(APISETC, this.dataSourceMiscelazione, false).then(ress => {
        let messages = ''
        if (ress != '') {
      
          for (let x in ress) {

            if (ress[x].id < 0) {
              messages += '<p>' + ress[x].descrizione + '</p>';
              alert(messages, 'Attenzione!');
              return;
            }

            messages += '<p>' + ress[x].descrizione + '</p>';
            rows[ress[x].id].classList.add('error-row')
            this.nicaDataGrid.rowSelected[ress[x].id] = true;
          }

          alert(messages, 'Attenzione!')
          return
        } else {
          let datatoSendOutputSave = {
            name: 'saveData',
            data: lista
          }

          this.outputEmit.emit(datatoSendOutputSave);
        }

      })
    }



  }
}
